module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ystad-69019e78d3eae35f5013012b9d322efb.png";